import React from "react";
import { RotateLoader } from "react-spinners";

export const Loader: React.FC = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
    }}
  >
    <RotateLoader color='#137667' size={20} />
  </div>
);
